import { useTranslation } from 'react-i18next';

import { useGetAssistantsQuery, useGetTextScenarioStarterKitsQuery } from '@/app/services/chatbot-rtk.services';
import { BotTypeEnum } from '@/utils/BotTypeEnum';

export const useGetTemplates = (type: BotTypeEnum) => {
  const { i18n } = useTranslation();

  const skip = !type;

  const {
    data: dataScenario,
    isLoading: isLoadingScenario,
    isError: isErrorScenario,
    isFetching: isFetchingScenario,
    isSuccess: isSuccessScenario,
    refetch: refetchScenario,
  } = useGetTextScenarioStarterKitsQuery(type, {
    skip: skip || type === BotTypeEnum.AI_READY_TO_USE,
  });

  const {
    data: dataAI,
    isLoading: isLoadingAI,
    isError: isErrorAI,
    isFetching: isFetchingAI,
    isSuccess: isSuccessAI,
    refetch: refetchAI,
  } = useGetAssistantsQuery({ language: i18n.language }, { skip: skip || type !== BotTypeEnum.AI_READY_TO_USE });

  const isLoading = isLoadingScenario || isLoadingAI;
  const isError = isErrorScenario || isErrorAI;
  const isFetching = isFetchingScenario || isFetchingAI;
  const isSuccess = isSuccessScenario || isSuccessAI;

  // Compose data and set hasRequiredPermission
  const templates = (dataScenario?.templates || []).map(item => ({ ...item, hasRequiredPermission: true }));
  const packages = (dataScenario?.packages || []).map(item => ({
    ...item,
    hasRequiredPermission: item.price === 0,
  }));
  const ai = (dataAI || []).map(item => ({ ...item }));
  const data = [...templates, ...packages, ...ai];
  const refetch = type === BotTypeEnum.AI_READY_TO_USE ? refetchAI : refetchScenario;

  return {
    isLoading,
    isError,
    isFetching,
    isSuccess,
    data,
    refetch,
  };
};
